import { ReactNode } from 'react'
import { Navigate, useLocation } from 'react-router-dom'
import { useAuthStore } from '../../core/stores/authStore'
import { canAccessRoute } from '../config/route-permissions'
import { AppRoute } from '../config/app-routes'

interface ProtectedRouteProps {
  children: ReactNode
}

export default function ProtectedRoute({ children }: ProtectedRouteProps) {
  const { isAuthenticated, isLoading, user } = useAuthStore()
  const location = useLocation()

  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="animate-spin rounded-full h-32 w-32 border-b-2 border-primary-600"></div>
      </div>
    )
  }

  if (!isAuthenticated) {
    // Redirect to login page with return url
    return <Navigate to={AppRoute.LOGIN_ROUTE} state={{ from: location }} replace />
  }

  // Check if user has permission to access this route
  if (user) {
    const hasAccess = canAccessRoute(
      location.pathname,
      user.userRole
    )

    if (!hasAccess) {
      // Redirect to access denied page if they don't have permission
      return <Navigate to={AppRoute.ACCESS_DENIED_ROUTE} state={{ from: location.pathname }} replace />
    }
  }

  return <>{children}</>
}